import { ColumnDetails, ColumnType } from '../../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { TimeRangeKind } from '@nirvana/shared/dtos/types/shared/time';
import { GridFilterUiConfiguration } from '../../../../../../../../types/filters/types';

export enum Column {
  DEVICE_NAME = 1,
  DEVICE_ID = 2,
  PRODUCT_ID = 3,
  COMPUTER_NAME = 4,
  LAST_CONNECTED = 5,
}

export enum ColumnKeys {
  DEVICE_NAME = 'deviceName',
  DEVICE_ID = 'deviceId',
  PRODUCT_ID = 'productId',
  COMPUTER_NAME = 'endpointIds',
  LAST_CONNECTED = 'lastDetectionDate',
}
export const GRID_COLUMNS = [
  Column.DEVICE_NAME,
  Column.DEVICE_ID,
  Column.PRODUCT_ID,
  Column.COMPUTER_NAME,
  Column.LAST_CONNECTED,
];

export function filtersUiConfigs(): Array<GridFilterUiConfiguration> {
  return [
    {
      key: ColumnKeys.LAST_CONNECTED,
      config: {
        activeRange: 365,
        enableSelectAllToDate: true,
        additionalTimeRangeOptions: [
          {
            label: translateFn('Last 90 days'),
            value: 90,
          },
          {
            label: translateFn('Last 180 days'),
            value: 180,
          },
          {
            label: translateFn('Last year'),
            value: 365,
          },
        ],
      },
    },
    {
      key: ColumnKeys.PRODUCT_ID,
      config: {
        min: 0,
      },
    },
  ];
}

export const FILTERS = [
  { [ColumnKeys.DEVICE_NAME]: { contains: '' } },
  { [ColumnKeys.DEVICE_ID]: { contains: '' } },
  { [ColumnKeys.PRODUCT_ID]: { equals: 0 } },
  { [ColumnKeys.COMPUTER_NAME]: { contains: '' } },
  {
    [ColumnKeys.LAST_CONNECTED]: {
      timeRange: {
        kind: TimeRangeKind.ALL_TO_DATE,
      },
    },
  },
];

export const PREDEFINED_FILTERS_KEYS = [
  ColumnKeys.DEVICE_NAME,
  ColumnKeys.DEVICE_ID,
  ColumnKeys.PRODUCT_ID,
  ColumnKeys.COMPUTER_NAME,
  ColumnKeys.LAST_CONNECTED,
];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.DEVICE_NAME,
      key: ColumnKeys.DEVICE_NAME,
      columnName: translateFn('Device name'),
      type: ColumnType.STRING,
      removable: false,
      sortable: true,
    },
    {
      column: Column.DEVICE_ID,
      key: ColumnKeys.DEVICE_ID,
      columnName: translateFn('Device ID'),
      type: ColumnType.STRING,
      removable: false,
      sortable: true,
    },
    {
      column: Column.PRODUCT_ID,
      key: ColumnKeys.PRODUCT_ID,
      columnName: translateFn('Product ID'),
      type: ColumnType.NUMBER,
      removable: false,
      sortable: true,
    },
    {
      column: Column.COMPUTER_NAME,
      key: ColumnKeys.COMPUTER_NAME,
      columnName: translateFn('Computer name'),
      type: ColumnType.STRING,
      removable: false,
      sortable: false,
    },
    {
      column: Column.LAST_CONNECTED,
      key: ColumnKeys.LAST_CONNECTED,
      columnName: translateFn('Last connected'),
      type: ColumnType.DATE,
      removable: false,
      sortable: true,
      filterResetValue: {
        timeRange: {
          kind: TimeRangeKind.ALL_TO_DATE,
        },
      },
    },
  ];
}
